<div *ngIf="active">
  <div *ngIf="(userGroupList$ | async) as userGroupList; else loadingTemplate">
    <div class="form-group" *ngIf="userGroupList.length > 0; else noDataTemplate">
      <label [hidden]="hideLabel" for="SelectUserGroup">{{ label }}</label>
      <ng-select required [items]="userGroupList" bindLabel="Name" bindValue="Code" [multiple]="false"
                 [hideSelected]="true"
                 [loading]="userGroupListLoading" [typeahead]="userGroupListinput$" [(ngModel)]="selectedUserGroupCode"
                 name="SelectUserGroup"
                 placeholder="{{selectUserGroupText}}" (change)=selectedUserGroupChanged($event)>
      </ng-select>
    </div>
    <ng-template #noDataTemplate>
      There are no user roles avaliable yet.
    </ng-template>
  </div>
  <ng-template #loadingTemplate>
    There are no user roles avaliable yet.
  </ng-template>
</div>
